/**
 * Extracts a human-readable error message from an axios error response.
 * Handles Pydantic v2 validation errors where `detail` is an array of objects.
 */
export function getApiError(error, fallback = 'Something went wrong') {
    const detail = error?.response?.data?.detail;
    if (!detail) return fallback;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
        return detail.map(d => d?.msg || JSON.stringify(d)).join('; ');
    }
    return fallback;
}
